module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (!_vm.loading) ? _c('div', _vm._l((_vm.favoriteSittersComp), function(sitter, index) {
    return (_vm.favoriteSittersComp && _vm.favoriteSittersComp.length > 0) ? _c('div', {
      staticClass: "col-sm-12 pull-right hidden-sm hidden-xs"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "sitterListbox "
    }, [(sitter.IsActive) ? _c('div', {
      staticClass: "ribbon-container",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.premiumSwal()
        }
      }
    }, [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "profile-img"
    }, [_c('img', {
      staticClass: "img-responsive img-rounded",
      staticStyle: {
        "cursor": "pointer",
        "min-width": "170px",
        "min-height": "170px",
        "border": "1px solid #c3c3c3"
      },
      attrs: {
        "src": sitter.ProfilePhotoUrl,
        "alt": "",
        "height": "240",
        "width": "240"
      },
      on: {
        "click": function($event) {
          _vm.viewProfile(sitter)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "profile-body "
    }, [_c('div', {
      staticClass: "profile-body-details"
    }, [_c('h2', [_vm._v(_vm._s(sitter.Name))]), _vm._v(" "), _c('div', {
      staticClass: "home-details align-right"
    }, [_c('div', {
      staticClass: "homewrapper"
    }, [(sitter.IsHasCat) ? _c('div', {
      staticClass: "home-icons",
      attrs: {
        "data-toggle": "popover",
        "data-trigger": "hover",
        "data-placement": "top",
        "data-container": "body",
        "data-content": "Resident cat at home"
      }
    }, [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), (sitter.IsHasDog) ? _c('div', {
      staticClass: "home-icons",
      attrs: {
        "data-toggle": "popover",
        "data-trigger": "hover",
        "data-placement": "top",
        "data-container": "body",
        "data-content": "Resident dog at home"
      }
    }, [_vm._m(3, true)]) : _vm._e(), _vm._v(" "), (sitter.IsHasChildren) ? _c('div', {
      staticClass: "home-icons",
      attrs: {
        "data-toggle": "popover",
        "data-trigger": "hover",
        "data-placement": "top",
        "data-container": "body",
        "data-content": "Children at home"
      }
    }, [_vm._m(4, true)]) : _vm._e(), _vm._v(" "), (!sitter.IsSmokeFree) ? _c('div', {
      staticClass: "home-icons",
      attrs: {
        "data-toggle": "popover",
        "data-trigger": "hover",
        "data-placement": "top",
        "data-container": "body",
        "data-content": "Smoke allowed at home"
      }
    }, [_vm._m(5, true)]) : _vm._e()])]), _vm._v(" "), _c('div', [(_vm.isFavorite(sitter.SitterId) == true) ? _c('span', {
      staticClass: "fa fa-2x favorite",
      staticStyle: {
        "margin-top": "2px"
      },
      attrs: {
        "data-container": "body",
        "data-toggle": "popover",
        "data-trigger": "hover",
        "data-placement": "top",
        "data-content": "Remove From Favorites"
      },
      on: {
        "click": function($event) {
          _vm.addToFavorites(sitter)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-heart"
    })]) : _c('span', {
      staticClass: "fa fa-2x favorite",
      staticStyle: {
        "margin-top": "2px"
      },
      attrs: {
        "data-toggle": "popover",
        "data-trigger": "hover",
        "data-container": "body",
        "data-placement": "top",
        "data-content": "Add to Favorites"
      },
      on: {
        "click": function($event) {
          _vm.addToFavorites(sitter)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-heart-o"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "bottom-row"
    }, [_c('div', {
      staticClass: "content"
    }, [(sitter.RatingAvg) ? _c('div', [_vm._l((sitter.RatingAvg), function(n) {
      return _c('i', {
        staticClass: "fa fa-star fa-1x inline",
        staticStyle: {
          "color": "#ffd118",
          "font-size": "18px"
        }
      })
    }), _vm._v(" "), _c('h6', {
      staticClass: "text-muted inline reviews small"
    }, [_vm._v("   " + _vm._s(sitter.RatingCount) + " Reviews")])], 2) : _vm._e(), _vm._v(" "), _c('h6', {
      staticClass: "text-muted",
      staticStyle: {
        "padding-top": "2px",
        "margin-top": "0px"
      }
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    }), _vm._v(" " + _vm._s(sitter.Location))]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "padding-top": "0px",
        "margin-top": "0px"
      }
    }, [_vm._v(_vm._s(sitter.Title))]), _vm._v(" "), _c('p', {
      staticClass: "text-overflow"
    }, [_vm._v(" " + _vm._s(sitter.AboutMe))])])])])]), _vm._v(" "), (!sitter.RepeatedStays == 0) ? _c('div', {
      staticStyle: {
        "padding-left": "10px",
        "padding-right": "10px"
      }
    }, [_c('hr', {
      staticStyle: {
        "margin": "5px"
      }
    }), _vm._v(" "), (!sitter.AverageResponseTime == 0) ? _c('figure', {
      staticClass: "performance"
    }, [_vm._m(6, true), _vm._v(" "), _c('strong', [_c('p', {
      staticClass: "small text-center"
    }, [_vm._v(_vm._s(sitter.AverageResponseTime))])])]) : _vm._e(), _vm._v(" "), (!sitter.RepeatedStays == 0) ? _c('figure', {
      staticClass: "performance"
    }, [_vm._m(7, true), _vm._v(" "), _c('strong', [_c('p', {
      staticClass: "small text-center"
    }, [_vm._v(_vm._s(sitter.RepeatedStays) + " times")])])]) : _vm._e(), _vm._v(" "), _c('figure', {
      staticClass: "performance pull-right"
    }, [_vm._m(8, true), _vm._v(" "), _c('strong', [_c('p', {
      staticClass: "small text-center"
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("From ")]), _vm._v(" "), _c('strong', {
      staticStyle: {
        "color": "#feb34f"
      }
    }, [_vm._v(_vm._s(sitter.Price))]), _c('span', {
      staticClass: "small"
    }, [_vm._v(" " + _vm._s(_vm.currencyComp))])])])])]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn-block btn btn-success btn-title ",
      staticStyle: {
        "margin-top": "10px"
      },
      on: {
        "click": function($event) {
          _vm.viewProfile(sitter)
        }
      }
    }, [_vm._v("Visit Profile")])])]) : _vm._e()
  })) : _vm._e(), _vm._v(" "), _vm._l((_vm.favoriteSittersComp), function(sitter, index) {
    return (_vm.favoriteSittersComp && _vm.favoriteSittersComp.length > 0) ? _c('div', {
      staticClass: "col-xs-12  hidden-md hidden-lg ",
      staticStyle: {
        "padding": "0px",
        "margin": "0px"
      }
    }, [_c('div', {
      staticClass: "sittersListMobile"
    }, [(sitter.IsActive) ? _c('div', {
      staticClass: "ribbon",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.premiumSwal()
        }
      }
    }, [_vm._v("Premium "), _c('i', {
      staticClass: "fa fa-paw"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "small-border"
    }, [_c('div', {
      staticClass: "media-body"
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('img', {
      staticClass: "media-object img-responsive img-rounded",
      staticStyle: {
        "min-width": "60px",
        "min-height": "60px",
        "border": "1px solid #c3c3c3"
      },
      attrs: {
        "src": sitter.ProfilePhotoUrl,
        "alt": "",
        "height": "80",
        "width": "80"
      },
      on: {
        "click": function($event) {
          _vm.viewProfile(sitter)
        }
      }
    }), _vm._v(" "), (sitter.IsOnline == true) ? _c('div', {
      staticClass: "rank-label-container",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.viewProfile(sitter)
        }
      }
    }, [_c('span', {
      staticClass: "label label-default rank-label"
    }, [_vm._v(" Online")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "media-left head-title"
    }, [_c('h4', {
      staticStyle: {
        "padding-bottom": "0px",
        "margin-bottom": "0px"
      }
    }, [_c('strong', [_vm._v(_vm._s(sitter.Name))])]), _vm._v(" "), (sitter.RatingAvg) ? _c('div', [_vm._l((sitter.RatingAvg), function(n) {
      return _c('i', {
        staticClass: "fa fa-star fa-1x inline",
        staticStyle: {
          "margin": "0px",
          "color": "#ffd118",
          "font-size": "15px"
        }
      })
    }), _vm._v(" "), _c('h5', {
      staticClass: "text-muted inline reviews",
      staticStyle: {
        "padding": "0px",
        "margin": "0px",
        "font-size": "15px"
      }
    }, [_vm._v("   " + _vm._s(sitter.RatingCount) + " Reviews")])], 2) : _vm._e(), _vm._v(" "), _c('h6', {
      staticClass: "text-muted",
      staticStyle: {
        "padding-top": "2px",
        "margin-top": "2px"
      }
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    }), _vm._v(" " + _vm._s(sitter.Location))])]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "padding-top": "5px",
        "margin-top": "5px",
        "padding-bottom": "2px",
        "margin-bottom": "2px"
      }
    }, [_vm._v(_vm._s(sitter.Title))]), _vm._v(" "), _c('p', {
      staticClass: "text-overflow"
    }, [_vm._v(" " + _vm._s(sitter.AboutMe))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9",
      staticStyle: {
        "padding-left": "0px",
        "margin-left": "0px"
      }
    }, [_c('button', {
      staticClass: "btn btn-success btn-block btn-title",
      on: {
        "click": function($event) {
          _vm.viewProfile(sitter)
        }
      }
    }, [_vm._v("Visit Profile")]), _vm._v(" "), (_vm.isFavorite(sitter.SitterId) == true) ? _c('button', {
      staticClass: "btn btn-info btn-block btn-title",
      attrs: {
        "lazy": ""
      },
      on: {
        "click": function($event) {
          _vm.addToFavorites(sitter)
        }
      }
    }, [_vm._v("Added to favorites "), _c('i', {
      staticClass: "fa fa-heart"
    })]) : _c('button', {
      staticClass: "btn btn-info btn-block btn-title",
      attrs: {
        "lazy": ""
      },
      on: {
        "click": function($event) {
          _vm.addToFavorites(sitter)
        }
      }
    }, [_vm._v("Add to favorites "), _c('i', {
      staticClass: "fa fa-heart-o",
      staticStyle: {
        "color": "white"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 price-wrap"
    }, [_c('div', {
      staticClass: "pricing-head-mobile"
    }, [_c('h4', [_c('span', [_vm._v("from")]), _vm._v(_vm._s(sitter.Price)), _c('span', [_vm._v(_vm._s(_vm.currencyComp) + "/day")])])])])])])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.loading && _vm.favoriteSittersComp.length == 0) ? _c('div', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("There are no Favorite Sitters added, please go to "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.goFindSitters()
      }
    }
  }, [_vm._v("Find Sitters")]), _vm._v(" to add favorites")])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(9)]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o"
  }), _vm._v(" My Favorite Sitters")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_blank"
    }
  }, [_vm._v("Premium "), _c('i', {
    staticClass: "fa fa-paw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../Sitters/images/ResidentCat.png"),
      "height": "25",
      "width": "25"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../Sitters/images/ResidentDog.png"),
      "height": "25",
      "width": "25"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../Sitters/images/HasChildren.png"),
      "height": "25",
      "width": "25"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../Sitters/images/Smoke.png"),
      "height": "25",
      "width": "25"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figcaption', {
    staticClass: "small text-center"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Response Time ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figcaption', {
    staticClass: "small text-center"
  }, [_c('i', {
    staticClass: "fa fa-handshake-o"
  }), _vm._v(" Repeated Bookings ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figcaption', {
    staticClass: "small text-center"
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Price Rates ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b3fe248!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/MyFavoriteSitters.vue
// module id = 625
// module chunks = 2